module.exports = __webpack_public_path__ + "img/Lock.5994a1e5.svg";